/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import SVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import { ButtonMenuStyled } from './styles';

function ButtonMenuHeader({ label, icon, path, onClick }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      return navigate(path, { replace: true });
    }
    return onClick();
  };

  return (
    <ButtonMenuStyled>
      <div onClick={handleClick}>
        <SVG className="svg" src={icon} width={24} />
        <span>{label}</span>
      </div>
    </ButtonMenuStyled>
  );
}

export default ButtonMenuHeader;

ButtonMenuHeader.defaultProps = {
  path: null,
  onClick: () => {},
};

ButtonMenuHeader.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  path: PropTypes.string,
  onClick: PropTypes.func,
};
